import type { PriceTier } from '../types';

interface PriceTierBadgeProps {
  tier: PriceTier;
  price: number | null;
  currency?: string;
  size?: 'sm' | 'md' | 'lg';
}

const tierConfig = {
  low: {
    label: 'Budget',
    color: 'text-green-700 dark:text-green-400',
    bgColor: 'bg-green-50 dark:bg-green-900/30',
    borderColor: 'border-green-200 dark:border-green-800',
  },
  medium: {
    label: 'Mid-Range',
    color: 'text-amber-700 dark:text-amber-400',
    bgColor: 'bg-amber-50 dark:bg-amber-900/30',
    borderColor: 'border-amber-200 dark:border-amber-800',
  },
  high: {
    label: 'Premium',
    color: 'text-red-700 dark:text-red-400',
    bgColor: 'bg-red-50 dark:bg-red-900/30',
    borderColor: 'border-red-200 dark:border-red-800',
  },
};

const sizeConfig = {
  sm: 'text-xs px-2 py-0.5',
  md: 'text-sm px-3 py-1',
  lg: 'text-base px-4 py-1.5',
};

export function PriceTierBadge({
  tier,
  price,
  currency = 'ZAR',
  size = 'md',
}: PriceTierBadgeProps) {
  const config = tierConfig[tier];

  const formatPrice = (value: number | null) => {
    if (value === null) return 'N/A';
    return new Intl.NumberFormat('en-ZA', {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(value);
  };

  return (
    <div
      className={`inline-flex flex-col items-center rounded-lg border ${config.bgColor} ${config.borderColor} ${sizeConfig[size]}`}
    >
      <span className={`font-medium ${config.color}`}>{config.label}</span>
      <span className={`font-bold ${config.color}`}>{formatPrice(price)}</span>
    </div>
  );
}
